import { render, staticRenderFns } from "./LogoLink.vue?vue&type=template&id=4a6c7f0e"
import script from "./LogoLink.vue?vue&type=script&lang=js"
export * from "./LogoLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports